import Raven from 'raven-js'
import sentryPsPlugin from '@patsnap/common-ps-tracer'
import { getServiceArea } from '@patsnap/common-ps-tracer/src/consts'
import _ from 'lodash'

const unpushedTrackEventsStack = []

let inited = false;

function setSentry({ email = '', account_id_cipher = '', company_id_cipher = '', user_type = '' }) {
    if (window.location.search.includes('noraven')) {
        return
    }
    if (inited) {
        return;
    }

    if (process.env.NODE_ENV !== 'development' && !(Raven._globalContext && Raven._globalContext.user)) {
        // 开发环境下不拦截错误
        Raven.setUserContext({
            email,
            account_id_cipher,
            company_id_cipher,
            user_type,
            client_id: process.env.VUE_APP_CLIENT_ID,
        })
        sentryPsPlugin(Raven, {
            product: 'console',
            SEGMENT_WRITE_KEY: process.env.VUE_APP_SEGMENT_WRITE_KEY,
            albLog: false,
            redShiftIntegrationName: 'redshift-segmentdb',
            openSpendTimeTrack: true,
            page: 'Admin',
        })

        inited = true;
    }
}

const RavenInsertMeta = (category, action, attr) => {
    const region = getServiceArea().toUpperCase()
    attr = _.merge({
        region,
    }, attr)
    const trackData = {
        module: category,
        action,
        attr,
    };
    Raven.insertMeta(trackData)
};

Raven.insertMeta = Raven.insertMeta
    ? Raven.insertMeta
    : (trackData) => {
        console.warn('ps-tracer not inited!')
        unpushedTrackEventsStack.push(trackData)
    }

export {
    setSentry,
    RavenInsertMeta,
}
